export const DEFAULT_SSO_COOKIE_DOMAIN = 'headliner.app';
export const DEFAULT_SSO_LOCALHOST_COOKIE_DOMAIN = 'localhost';
export const MEDIA_TOS_URL =
  'https://www.headliner.app/docs/media-use-terms.html?_ga=2.36179680.1788256323.1665664716-147277577.1643297664';
export const PRIVACY_POLICY_URL =
  'https://www.headliner.app/docs/privacy-policy.html?_ga=2.36179680.1788256323.1665664716-147277577.1643297664';
export const TOS_URL =
  'https://www.headliner.app/docs/terms-of-service.html?_ga=2.28250108.1788256323.1665664716-147277577.1643297664';
